import React, { useContext, useEffect, useState } from 'react';
import './login.css';
import { useNavigate } from 'react-router-dom';
import loginBackgroundImage from '../../Assets/Images/loginBackgroundImage.jpg';
import { reset_password } from '../../Services/Login/LoginApi';
import AlertModal from '../../Componant/AlertModel';
import { LoaderContext } from '../../Context/ContextProvider';
import SuccessModel from '../../Componant/SuccessModel';

const RestPassword = () => {
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState('');
  const [isAlertOpen, setIsAlertOpen] = useState(false); // for error alert
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [RetypePasswordVisible, setRetypePasswordVisible] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordStrength, setPasswordStrength] = useState('');
  const [isSuccessOpen, setIsSuccessOpen] = useState(false); // for error alert

  const [message, setMessage] = useState('');
  const [ErrorMessage, setErrorMessage] = useState('');
  const { setLoader } = useContext(LoaderContext);
  useEffect(() => {
    const isAllowed = sessionStorage.getItem('allowResetPassword');
    if (!isAllowed) {
      // 🚫 Block direct access and redirect
      navigate('/unauthorized'); // or homepage/login
    } else {
      // ✅ Optional: Remove flag so it's one-time use
      sessionStorage.removeItem('allowResetPassword');
    }
  }, []);
  const handleResetPassword = async () => {
    let validationErrors = [];

    if (!newPassword || !confirmPassword) {
      validationErrors.push('All fields are required.');
    }

    if (newPassword.length < 8) {
      validationErrors.push('Password must be at least 8 characters long.');
    }

    if (!/[A-Z]/.test(newPassword)) {
      validationErrors.push('Password must contain at least one uppercase letter.');
    }

    if (!/[a-z]/.test(newPassword)) {
      validationErrors.push('Password must contain at least one lowercase letter.');
    }

    if (!/\W/.test(newPassword)) {
      validationErrors.push('Password must contain at least one special character.');
    }

    if (newPassword !== confirmPassword) {
      validationErrors.push('Passwords do not match.');
    }

    if (validationErrors.length > 0) {
      const errorMessage = validationErrors.includes('Passwords do not match.')
        ? 'Passwords must match.'
        : validationErrors.includes('All fields are required.')
          ? 'All fields are required.'
          : 'Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, and one special character.';

      setErrorMessage(errorMessage);
      setIsAlertOpen(true);
      return;
    }

    try {
      setLoader(true);
      const response = await reset_password({ new_password: newPassword });

      if (!response?.code?.includes('ERR')) {
        setMessage('Password reset successfully.');
        setIsSuccessOpen(true);
        setNewPassword('');
        setConfirmPassword('');
        setPasswordStrength('');
      } else {
        setIsAlertOpen(true);
        setErrorMessage(response?.response?.data?.error || 'Failed to reset password. Please try again.');
      }
      setLoader(false);
    } catch (err) {
      setErrorMessage('Something went wrong. Please try again later.');
      setIsAlertOpen(true);
      setLoader(false);
      console.error(err);
    }
  };

  const handleResetPasswordSubmit = event => {
    event.preventDefault();
    handleResetPassword();
  };

  const handlePasswordChange = value => {
    setNewPassword(value);

    // Password Strength Calculation
    let strength = 0;
    if (value.length >= 8) strength++;
    if (/[A-Z]/.test(value)) strength++;
    if (/[a-z]/.test(value)) strength++;
    if (/\W/.test(value)) strength++;

    if (strength <= 2) setPasswordStrength('Weak');
    else if (strength === 3) setPasswordStrength('Fair');
    else if (strength === 4) setPasswordStrength('Strong');
    else setPasswordStrength('');
  };
  const getStrengthColor = strength => {
    switch (strength) {
      case 'Weak':
        return '#dc3545'; // red
      case 'Fair':
        return '#ffc107'; // yellow/orange
      case 'Strong':
        return '#28a745'; // green
      default:
        return '#6c757d'; // gray
    }
  };

  const getStrengthWidth = strength => {
    switch (strength) {
      case 'Weak':
        return '33%';
      case 'Fair':
        return '66%';
      case 'Strong':
        return '100%';
      default:
        return '0%';
    }
  };

  return (
    <div className="signup-wrapper">
      <div className="signup-card">
        <div className="signup-left">
          <img src={loginBackgroundImage} alt="Sign Up Visual" className="inline-logo" />
          <div className="info-cards">
            <div className="info-card">
              <span className="info-card-value">2x</span>
              <br />
              <span className="info-card-label">Job Matches</span>
            </div>
            <div className="info-card">
              <span className="info-card-value">50%</span>
              <br />
              <span className="info-card-label">Time Saving in Job Searches</span>
            </div>
            <div className="info-card">
              <span className="info-card-value">95%</span>
              <br />
              <span className="info-card-label">Score on mostly all ATS</span>
            </div>
            <div className="info-card">
              <span className="info-card-value">50%</span>
              <br />
              <span className="info-card-label">More Interview Invites</span>
            </div>
          </div>
        </div>

        <div className="signup-right">
          <h2 onClick={() => navigate('/')} className="welcome-heading">
            <img src={`${process.env.PUBLIC_URL}/assets/images/logo/SeekJobsLog1.png`} alt="SeekJobs" className="inline-logo" />
          </h2>
          <h3>Forgot your password? No worries, enter a new password for your account!</h3>
          <form className="signup-form" onSubmit={handleResetPasswordSubmit}>
            <div className="form-group-login">
              <label className="login-label" htmlFor="newPassword">
                New Password
              </label>
              <div className="password-wrapper">
                <input
                  type={passwordVisible ? 'text' : 'password'}
                  id="newPassword"
                  name="newPassword"
                  placeholder="Enter New Password"
                  className="password-input"
                  value={newPassword}
                  onChange={e => handlePasswordChange(e.target.value)}
                />
                <span className="toggle-password" onClick={() => setPasswordVisible(!passwordVisible)}>
                  {!passwordVisible ? <i className="fas fa-eye-slash"></i> : <i className="fas fa-eye"></i>}
                </span>
              </div>
              {newPassword && (
                <div className="text-start" style={{ marginTop: '5px' }}>
                  <div style={{ fontWeight: 'bold' }}>Password Strength: {passwordStrength}</div>
                  <div
                    style={{
                      height: '8px',
                      width: '100%',
                      backgroundColor: '#e0e0e0',
                      borderRadius: '4px',
                      marginTop: '5px',
                    }}
                  >
                    <div
                      style={{
                        height: '100%',
                        width: getStrengthWidth(passwordStrength),
                        backgroundColor: getStrengthColor(passwordStrength),
                        borderRadius: '4px',
                        transition: 'width 0.3s ease',
                      }}
                    />
                  </div>
                  {/* Inline password policy validation */}
                  <ul className="text-danger mt-2 mb-0 ps-3" style={{ fontSize: '12px' }}>
                    {newPassword.length < 8 && <li>Password must be at least 8 characters long.</li>}
                    {!/[A-Z]/.test(newPassword) && <li>Password must contain at least one uppercase letter.</li>}
                    {!/[a-z]/.test(newPassword) && <li>Password must contain at least one lowercase letter.</li>}
                    {!/\W/.test(newPassword) && <li>Password must contain at least one special character.</li>}
                  </ul>
                </div>
              )}
            </div>

            <div className="form-group-login">
              <label className="login-label" htmlFor="confirmPassword">
                Retype New Password
              </label>
              <div className="password-wrapper">
                <input
                  type={RetypePasswordVisible ? 'text' : 'password'}
                  id="confirmPassword"
                  name="confirmPassword"
                  placeholder="Retype New Password"
                  className="password-input"
                  value={confirmPassword}
                  onChange={e => setConfirmPassword(e.target.value)}
                />
                <span className="toggle-password" onClick={() => setRetypePasswordVisible(!RetypePasswordVisible)}>
                  {!RetypePasswordVisible ? <i className="fas fa-eye-slash"></i> : <i className="fas fa-eye"></i>}
                </span>
              </div>
              {confirmPassword !== newPassword ? <div className="text-danger text-start">Passwords do not match.</div> : ''}
            </div>

            <small className="text-muted">
              Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, and one special
              character.
            </small>

            <button type="submit" className="primary-btn" style={{ cursor: 'pointer', marginTop: '10px' }}>
              Update Password
            </button>
          </form>
        </div>

        {/* Alert Modal */}
        <SuccessModel
          isOpen={isSuccessOpen}
          title="Success!"
          message={message}
          buttonText="OK"
          onClose={() => {
            navigate('/');
            setIsSuccessOpen(false);
          }}
        />
        <AlertModal isOpen={isAlertOpen} title="Alert!" message={ErrorMessage} buttonText="Got it" onClose={() => setIsAlertOpen(false)} />
      </div>
    </div>
  );
};

export default RestPassword;
